import {createUseStyles} from 'react-jss'
import color from 'color';

import {
  BREAKPOINTS,
  COLORS
} from '~styles/vars.styles'

const Z_INDEX = 1;

export default createUseStyles({

  modalWrapper: {
    position: 'fixed',
    top: 0,
    left: 0,
    zIndex: Z_INDEX + 2,
    width: '100%',
    height: '100%',
    overflowX: 'hidden',
    overflowY: 'auto',
    outline: 0
  },

  modalOverlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    zIndex: Z_INDEX + 1,
    width: '100vw',
    height: '100vh',
    backgroundColor: COLORS.PURPLE_01,
    opacity: .65,
  },
  
  modal: {
    zIndex: Z_INDEX,
    background: 'white',
    position: 'relative',
    margin: '1.75rem auto',
    borderRadius: 6,
    maxWidth: 500,
    padding: 30,

    [`@media (min-width: ${BREAKPOINTS.MODAL_BIG}px)`]: {
      padding: 60,
    }
  },
  
  modalHeader: {
    display: 'flex'
  },

  modalTitle: {
    flex: 1,
    fontSize: 28,
    fontWeight: 600,
    letterSpacing: '-0.045em',
    lineHeight: '1.25em',
    marginBottom: 20
  },
  
  modalCloseButton: {
    alignItems: 'center',
    border: [2, 'solid', color(COLORS.BLUE_02).alpha(0.5).string()],
    borderRadius: '50%',
    color: COLORS.BLUE_02,
    cursor: 'pointer',
    display: 'flex',
    flex: 'none',
    height: 44,
    justifyContent: 'center',
    width: 44
  },

  modalBody: {}
})